
































































































import {Component, Vue} from 'vue-property-decorator'
import {$} from '@/facade'
import {NeoHelper} from '@/helpers/NeoHelper'
import {OrbitEndRoundStep} from '@/enums/OrbitEndRoundStep'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import {OrbitRound} from '@/model/resource/OrbitRound'
import {currentN3Network} from '@/helpers/NetworkModeRegistry'

@Component({
  computed: {
    OrbitEndRoundStep() {
      return OrbitEndRoundStep
    },
  },
  components: {
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitEndRoundModal extends Vue {
  currentStep: OrbitEndRoundStep = OrbitEndRoundStep.WAITING_SIGNATURE
  transactionHash: string | null = null

  mounted() {
    this.endRound()
  }

  async endRound() {
    try {
      const n3InvocationBuilder = getN3InvocationBuilder()
      const endOrbitRoundInvocationBuilder = n3InvocationBuilder.endOrbitRoundInvocation()

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        endOrbitRoundInvocationBuilder
      )
      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitEndRoundStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      // Only this network's rounds: the signature went to this network's contract.
      await OrbitRound.setAllRoundsNotRunning(currentN3Network())

      this.currentStep = OrbitEndRoundStep.ENDED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }

    this.closeModal()
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitEndRoundStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitEndRoundStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitEndRoundStep.WAITING_SIGNATURE
    this.$emit('close')
  }

  private threatError(error: any) {
    console.error(error)

    if (String(error.message).includes('round period not yet ended')) {
      $.toast.error(
        'You can’t end the round yet. Wait for it to finish or use "Force End Round".'
      )
    }

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitEndRoundStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitEndRoundStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitEndRoundStep.UNKNOWN_ERROR
  }
}
